import React from 'react'
import { Box, Flex } from 'ui/acro'
import {
  AccountIcon,
  DashboardIcon,
  GiftIcon,
  LabelIcon,
  PhoneIcon,
  TicketIcon,
  VideoIcon,
  FireIcon
} from 'components_v2/Icons'
import Text from 'ui/acro/typography/Text'
import styled, { css } from 'styled-components'

const IconToCategoryMapping = {
  Account: AccountIcon,
  'Classes & Series': VideoIcon,
  Devices: PhoneIcon,
  'Free Trial': LabelIcon,
  Features: DashboardIcon,
  Membership: TicketIcon,
  Gifting: GiftIcon,
  'Live Classes': FireIcon
}

const StyledLink = styled(Flex)(() =>
  css({
    aspectRatio: '1/1',
    '&:hover': {
      background: '#F2F2F2',
      boxShadow:
        '0px 1px 4px rgba(0, 0, 0, 0.06), 0px 8px 16px rgba(35, 41, 54, 0.08)'
    },
    '&.disabled': {
      '&:hover': {
        background: 'transparent'
      },
      svg: {
        opacity: '0.3'
      }
    }
  })
)

const LargeButton = ({ href, label, disabled }) => {
  const Icon = IconToCategoryMapping[label] || AccountIcon
  return (
    <StyledLink
      border='1px solid #E1E1E1'
      as='a'
      className={`unstyled ${disabled && 'disabled'}`}
      borderRadius='4px'
      width={['100%']}
      href={disabled ? undefined : href}
      onClick={(event) => {
        if (disabled) {
          event.preventDefault()
        }
      }}
      flexDirection='column'
      gridArea='content'
      justifySelf='center'
      justifyContent='center'
      alignItems='center'
    >
      <Flex height='75px' pb={['0', '0', '20px', '20px']}>
        <Icon />
      </Flex>
      <Box>
        <Text
          fontFamily='Proxima-Nova'
          letterSpacing='.12em'
          fontSize={['13px', null, null, '16px']}
          fontStyle='normal'
          fontWeight={['400', null, null, '700']}
          textAlign='center'
          textTransform='uppercase'
          px={['13px']}
          lineHeight='18px'
          color={disabled && '#ccc'}
        >
          {label}
        </Text>
      </Box>
    </StyledLink>
  )
}

export default LargeButton
